var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M14 12.789 9.824 8.612a5.4 5.4 0 0 0 1.034-3.183A5.435 5.435 0 0 0 5.43 0 5.435 5.435 0 0 0 0 5.429a5.435 5.435 0 0 0 5.429 5.43 5.4 5.4 0 0 0 3.183-1.035L12.789 14zM5.429 9.143a3.715 3.715 0 1 1 0-7.429 3.715 3.715 0 0 1 0 7.43z"
})));
export default SvgSearch;